let seminarInfo = {
  result: 0,
  desc: "successful",
  content: {
    startTime: "1561251600",
    endTime: "1569664800",
    isOpenMember: "1",
    address: "北京浦项中心B座2层W1 Platform 多功能厅",
    status: "launched",
    weChatQrCodeUrl:
      "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQHE7zoAAAAAAAAAASxodHRwOi8vd2VpeGluLnFxLmNvbS9xL2lqOXg4VVhtblpya3FMdGwwQlBmAAIEjHI0VwMEAAAAAA==",
    title: "2021AI开发者大会",
    desc: "2021年世界互联网大会领先科技成果征集工作已经结束，来自全球互联网领域的近40位专家组成了领先科技成果专家推荐委员会，按照“公平、公正、客观、权威”的原则，对征集的成果进行推荐评选。最终将有15项左右年度领先的互联网科技成果在世界互联网大会乌镇峰会首日（26日）下午亮相。\n",
    guests: [
      {
        duty: "高级工程师",
        enterprise: "Spark中国开发中心、新技术研发中心高级工程师",
        name: "Andy Konwinski",
        realPath: "./images/avatar01.jpg",
      },
      {
        duty: "高级工程师",
        enterprise: "Spark中国开发中心、新技术研发中心高级工程师",
        name: "Andy Konwinski",
        realPath: "./images/avatar01.jpg",
      },
      {
        duty: "高级工程师",
        enterprise: "Spark中国开发中心、新技术研发中心高级工程师",
        name: "Andy Konwinski",
        realPath: "./images/avatar01.jpg",
      },
    ],
    agendas: [
      {
        agendaDate: 1562548200,
        items: [
          {
            name: "大数据广泛应用于企业的流程建模、流程控制盒业务运营。",
            startTime: "1561251600",
            endTime: "1561252200",
            guests: [
              {
                duty: "高级工程师",
                name: "嘉宾",
                guestType: "演讲者",
              },
            ],
          },
          {
            name: "大数据广泛应用于企业的流程建模、流程控制盒业务运营。",
            startTime: "1561251600",
            endTime: "1561252200",
            guests: [
              {
                duty: "高级工程师",
                name: "嘉宾",
                guestType: "演讲者",
              },
            ],
          },
          {
            name: "大数据广泛应用于企业的流程建模、流程控制盒业务运营。",
            startTime: "1561251600",
            endTime: "1561252200",
            guests: [
              {
                duty: "高级工程师",
                name: "嘉宾",
                guestType: "演讲者",
              },
            ],
          },
        ],
      },
      {
        agendaDate: 1562548200,
        itemsSubSeminar: [
          {
            subSeminarName: "分会场",
            subSeminarAddress: "分会场",
            subSeminarStartTime: "1561251600",
            subSeminarEndTime: "1561252200",
            items: [
              {
                name: "大数据广泛应用于企业的流程建模、流程控制盒业务运营。",
                startTime: "1561251600",
                endTime: "1561252200",
                guests: [
                  {
                    duty: "高级工程师",
                    name: "嘉宾",
                    guestType: "演讲者",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
export default seminarInfo;
